import { render, staticRenderFns } from "./lp-portfolio-performance.vue?vue&type=template&id=0f1c2378&scoped=true"
import script from "./lp-portfolio-performance.vue?vue&type=script&lang=js"
export * from "./lp-portfolio-performance.vue?vue&type=script&lang=js"
import style0 from "./lp-portfolio-performance.vue?vue&type=style&index=0&id=0f1c2378&prod&scoped=true&lang=css"
import style1 from "./lp-portfolio-performance.vue?vue&type=style&index=1&id=0f1c2378&prod&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f1c2378",
  null
  
)

export default component.exports